import { Button, Modal } from 'antd';

import { formatPackList } from '../../../_utils/formatPackList';

import styles from './MustHavePacksConfirmationModal.module.scss';

type Props = {
  isOpened: boolean;
  packNames: string[];
  isLoading?: boolean;
  handleCancel: () => void;
  handleSaveChange: () => void;
};

export const MustHavePacksConfirmationModal = ({
  isOpened,
  packNames,
  isLoading,
  handleCancel,
  handleSaveChange,
}: Props) => {
  const isSinglePack = packNames.length === 1;

  return (
    <Modal
      className={styles.modal}
      wrapClassName={styles.mustHavePacksConfirmationModal}
      open={isOpened}
      title="Apply your changes?"
      onCancel={handleCancel}
      footer={[
        <Button size="large" key="back" type="ghost" onClick={handleCancel}>
          Back to configure
        </Button>,
        <Button
          key="save"
          size="large"
          type="primary"
          onClick={handleSaveChange}
          loading={isLoading}
        >
          Confirm changes
        </Button>,
      ]}
    >
      <p>
        This activity is a must-have in {formatPackList(packNames)}.
        <br />
        If unavailable,{' '}
        <b>
          {isSinglePack
            ? 'this package may no longer be available for sale'
            : 'these packages may no longer be available for sale'}
        </b>
        .
      </p>
    </Modal>
  );
};
